import { handleResponse, handleError } from '../apiUtils';
import axiosInstance from '../axiosConfig';
import { getTrialContainerBaseUrl } from './trialContainerUtils';

export function trialContainerFetchRequest(accountId, identifier, params = null) {
  const baseUrl = getTrialContainerBaseUrl(accountId);

  return axiosInstance
    .request({
      method: 'get',
      url: `${baseUrl}/${identifier}`,
      params: params,
    })
    .then(handleResponse)
    .catch(handleError);
}

export default trialContainerFetchRequest;
